import { FunctionComponent, useEffect, useState, useRef } from "react";
import { addNoteFirebase, createTaskFirebase, fetchConstants } from "../../../Services/contacts";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../../Redux/actions";
import moment from "moment";
import Firebase from "firebase/app";
import { useHistory, useLocation } from "react-router-dom";
import TextInput from "../../TextInput/InputText";
import { themeColors } from "../../theme";
import { getLocation } from "../../../Values/utils";
import "../../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Modal, { Styles } from "react-modal";
import DropDown from "../../../Screens/LeadDistributorLogic/Dropdown"
import InputTextDate from "../../TextInput/InputTextDate";
import StyledCancelButton from "../../Buttons/StyledCancelButton";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";

/* ------------------------------------------------------------------
   TYPES
-------------------------------------------------------------------*/
type props = {
  contactDetail: any;
  close: () => void;
  open: boolean;
  tasksData: any[];
  user: any;
  notes: any[];
  theme: any;
  conatctHeader: any;
};

const CallBackModal: FunctionComponent<props> = ({
  contactDetail,
  close,
  open,
  tasksData,
  user,
  notes,
  theme,
  conatctHeader,
}) => {
  /** ----------------------------------------------
*  Responsive Logic (MUI Breakpoints)
* ---------------------------------------------- */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const dispatcher = useDispatch();
  const history = useHistory();
  const location: any = useLocation();
  const noteRef: any = useRef();

  // Loader state
  const [load, setLoad] = useState(false);

  // ------------- MASTER DATA LISTS (OPTIONS) -------------------
  const [nextFollowDate, setNextFollowDate] = useState<any>('');
  const [callBackSelected, setCallBackSelected] = useState<any>({ label: contactDetail.call_back_reason ? contactDetail.call_back_reason : "Select", value: contactDetail.call_back_reason ? contactDetail.call_back_reason : "Select" });
  const [propertyTypeList, setPropertyTypeList] = useState<any[]>([]);
  const [propertyStageList, setPropertyStageList] = useState<any[]>([]);
  const [nextFollowUpList, setnextFollowUpList] = useState<any[]>([]);
  const [notIntReasonList, setNotIntReasonList] = useState<any[]>([]);
  const [lostReasonList, setLostReasonList] = useState<any[]>([]);
  const [callbackList, setCallBackList] = useState<any[]>([]);
  const [latitude, setLatitude] = useState<any>(null);
  const [longitude, setLongitude] = useState<any>(null);

  // ----------------------------------------------------------
  // Get user location on mount
  // ----------------------------------------------------------
  useEffect(() => {
    (async () => {
      try {
        const position = await getLocation();
        if (position) {
          setLatitude(position.latitude);
          setLongitude(position.longitude);
        }
      } catch (error) {
        console.error('Failed to fetch location:', error);
      }
    })();
  }, []);

  // ----------------------------------------------------------
  // Load constants (reasons, property types, callback list, etc.)
  // ----------------------------------------------------------
  useEffect(() => {
    const unsubConst = fetchConstants(
      (data) => setNotIntReasonList(data),
      (data) => setLostReasonList(data),
      (data) => setPropertyStageList(data),
      (data) => setPropertyTypeList(data),
      (data) => setnextFollowUpList(data),
      (data) => setCallBackList(data)
    );
    return () => {
      unsubConst();
    };
  }, []);

  // ----------------------------------------------------------
  // Submit handler
  // ----------------------------------------------------------
  const onSubmit = () => {
    if (callBackSelected.value === "Select") {
      dispatcher(showSnackbarAction("Please Select Reason", "error"));
    } else if (nextFollowDate < new Date()) {
      dispatcher(showSnackbarAction("Task Cannot be Schedule For Old Date & Time!", "error"));
    } else {
      const data = {
        call_back_reason: callBackSelected.value,
        due_date: moment(nextFollowDate).toDate(),
        type: "Call Back",
        status: "Pending",
        customer_name: contactDetail.customer_name,
      };
      const changeLeadData = contactDetail.stage === "CALLBACK" ? {} : { stage_change_at: Firebase.firestore.Timestamp.now() };
      if (noteRef.current.value.length !== 0) {
        addNoteFirebase(
          contactDetail.contactId,
          notes,
          noteRef.current.value,
          () => { },
          dispatcher,
          () => { },
          user.user_email
        );
      }

      // Create task + update lead
      createTaskFirebase(
        contactDetail.contactId,
        tasksData,
        data,
        {
          stage: "CALLBACK",
          call_back_reason: callBackSelected.value,
          next_follow_up_type: "Call Back",
          next_follow_up_date_time: moment(
            nextFollowDate
          ).toDate(),
          modified_at: Firebase.firestore.Timestamp.now(),
          ...changeLeadData,
        },
        (value: boolean) => setLoad(value),
        dispatcher,
        user,
        close,
        history,
        undefined,
        latitude,
        longitude
      );

      // Update router state
      location.state.detail.stage = "Call Back";
      location.state.detail.next_follow_up_date_time = moment(nextFollowDate).toDate();
      location.state.detail.modified_at = Firebase.firestore.Timestamp.now().toDate();
      location.state.detail.call_back_reason = callBackSelected.value;
    }
  };

  // ----------------------------------------------------------
  // Modal style
  // ----------------------------------------------------------
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme
        ? themeColors.cardBackgroundColor
        : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "40px 32px",
      width: 400,
      maxWidth: 400,
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      inset: "auto",
      margin: "auto",
    },
  };

  /* ------------------------------------------------------------------
 RENDER
-------------------------------------------------------------------*/
  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={modalStyle}
        ariaHideApp={false}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 380,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <form style={{ width: "100%" }}>
            <Box sx={{ mb: 2 }}>
              <h3
                style={{
                  color: theme ? "#272944" : "#fff",
                  fontFamily: "var(--font-family-main)",
                  fontSize: "var(--font-size-large)",
                  marginBottom: 24,
                  textAlign: "center",
                  fontWeight: 700,
                  letterSpacing: 0.5,
                }}
              >
                Call Back Details
              </h3>
            </Box>
            <Grid container spacing={2} sx={{ width: "100%" }}>
              {/* Callback Reason */}
              <Grid item xs={12} sm={12}>
                <DropDown
                  title={conatctHeader.find((obj: any) => obj.label === "call_back_reason").value}
                  option={callbackList}
                  selectedValue={callBackSelected.value === "Select" ? "" : callBackSelected}
                  setSelectedValue={(value) => {
                    setCallBackSelected(value);
                  }}
                  required={true}
                />
              </Grid>

              {/* Next Follow-up Date */}
              <Grid item xs={12} sm={12}>
                <InputTextDate
                  type="datetime-local"
                  title="Next Follow Up Date"
                  value={nextFollowDate}
                  onChange={(e: any) => setNextFollowDate(e.target.value)}
                  required={true}
                />
              </Grid>

              {/* Notes */}
              <Grid item xs={12} sm={12}>
                <TextInput
                  title="Note"
                  style={{ backgroundColor: "#fff" }}
                  ref={noteRef}
                />
              </Grid>
            </Grid>

            {/* Buttons */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 4,
                  width: "100%",
                }}
              >
                <Box style={{ marginRight: 8 }}>
                  <StyledCancelButton onClick={close} isMobile={isMobile}>
                    Cancel
                  </StyledCancelButton>
                </Box>
                <Box>
                  <StyledSubmitButton
                    onClick={onSubmit}
                    themeMode={themeMUI.palette.mode}
                    isMobile={isMobile}
                  >
                    {load ? (
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <Circles color="#fff" height={20} width={20} />
                      </span>
                    ) : (
                      <>Submit</>
                    )}
                  </StyledSubmitButton>
                </Box>
              </Box>
            </Grid>
          </form>
        </Box>
      </Modal >
    </>
  );
};

/* ------------------------------------------------------------------
   REDUX
-------------------------------------------------------------------*/
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    conatctHeader: state.contactHeaderList.data,
  };
};

export default connect(mapStateToProps)(CallBackModal);
